import uni from "../styles/univesal.module.css";
import { header, logo } from "./common";
import { LangIds, Languages, getLang } from "../langs/langs";

interface Props {
  lang: Languages;
  headerNum: String;
}

function Processing({lang, headerNum}: Props) {
  return (
    <>
    <div className={uni.container}>
      {header(getLang(LangIds.SELFIE_Header, lang), headerNum)}
      <div className={uni.spacerExtra}/>
      <div className={uni.spacerExtra}/>
      <div className={uni.spacerBig}/>
      <div className={uni.center}>
        <div className={uni.bigText}>{getLang(LangIds.PROCESS_Processing, lang)}</div>
      </div>
      <div className={uni.filler}/>
      <div className={uni.innerSmallCenterContainer}>
        {logo(getLang(LangIds.LOGO_Powered, lang))}
      </div>
    </div>
    </>
  );
}

export default Processing;
